"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotSessionDetailsController = function () {
  function BotSessionDetailsController($stateParams, BotSessionsService, AppContextService, NotificationService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BotSessionDetailsController);
    this.botSessionsService = BotSessionsService;
    this.appContextService = AppContextService;
    console.log($stateParams.botSessionId);
    this.botSessionId = $stateParams.botSessionId;
    this.getSessionDetails(this.botSessionId);
    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
  }

  (0, _createClass3.default)(BotSessionDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      this.tabTypes = {
        PROFILE: 1,
        PAYMENT: 2,
        JOBS_AND_RATINGS: 3,
        CERTIFICATES: 4,
        MESSAGES: 5,
        RATINGS: 6
      };
    }
  }, {
    key: "getSessionDetails",
    value: function getSessionDetails(botSessionId) {
      var _this = this;

      this.isLoading = true;

      this.botSessionsService.getSessionDetails(botSessionId, function (response) {
        _this.botSession = response.data;
        _this.isLoading = false;

        _this.getTabs();
      }, function (error) {
        _this.isLoading = false;
      });
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      var _tabs;

      this.tabs = (_tabs = {}, (0, _defineProperty3.default)(_tabs, this.tabTypes.PROFILE, {
        key: 1,
        label: "PROFILE",
        isActive: true,
        icon: "fa fa-user"
      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.PAYMENT, {
        key: 2,
        label: "PAYMENT",
        isActive: false,
        icon: "fa fa-dollar"
      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.JOBS_AND_RATINGS, {
        key: 3,
        label: "JOBS & RATINGS",
        isActive: false,
        icon: "fa fa-user"
      }), (0, _defineProperty3.default)(_tabs, this.tabTypes.MESSAGES, {
        key: 4,
        label: "MESSAGES",
        isActive: false,
        icon: "fa fa-envelope"
      }), _tabs);
      this.activeTab = this.tabs["1"];
    }
  }, {
    key: "switchTab",
    value: function switchTab(tab) {
      var _this2 = this;

      this.activeTab = tab;

      (0, _keys2.default)(this.tabs).map(function (i) {
        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return _common2.default.formatDate(date);
    }
  }, {
    key: "hasGlobalAdminAccess",
    value: function hasGlobalAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
    }
  }]);
  return BotSessionDetailsController;
}();

exports.default = BotSessionDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/bot-session-details/bot-session-details.controller.js
 **/